import React from 'react';

const About = () => {
  return (
    <section id="about" className="py-20 px-4 bg-gray-800">
      <div className="container mx-auto">
        <h2 className="text-3xl font-bold mb-12 text-center">
          <span className="border-b-4 border-blue-400 pb-2">About Me</span>
        </h2>
        <div className="flex flex-col md:flex-row items-center">
          <div className="md:w-1/2 mb-10 md:mb-0 md:pr-10">
            <h3 className="text-2xl font-semibold mb-4 text-blue-400">
              Education
            </h3>
            <div className="bg-gray-700 p-6 rounded-lg mb-6">
              <h4 className="text-xl font-medium mb-2">
                National Institute of Technology, Silchar
              </h4>
              <p className="text-gray-300 mb-1">
                B.Tech in Electronics and Instrumentation — CGPA: 8.6/10
              </p>
              <p className="text-gray-400 text-sm">July 2019 – June 2023</p>
              <div className="mt-3">
                <p className="text-gray-300">
                  <span className="font-medium">Relevant Coursework:</span> Data Structures & Algorithms, OOP, DBMS, Computer Networks
                </p>
              </div>
            </div>
          </div>
          <div className="md:w-1/2">
            <h3 className="text-2xl font-semibold mb-4 text-blue-400">
              Who I Am
            </h3>
            <p className="text-gray-300 mb-6">
              I'm a passionate Full Stack Developer with expertise in JavaScript/TypeScript, React, Node.js, and cloud technologies. I specialize in building scalable microservices and optimizing system performance.
            </p>
            <p className="text-gray-300 mb-6">
              With experience at PwC and other tech companies, I've successfully designed systems that improve efficiency by up to 100% through automation and integration.
            </p>
            <p className="text-gray-300">
              When I'm not coding, I enjoy solving DSA problems (600+ solved) and participating in hackathons.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;